import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

export interface AlertBoxStyleProps {
  colorStyle: 'blue' | 'red' | 'yellow' | 'green' | 'orange';
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    padding: 8,
    borderRadius: 8,
    display: 'flex',
    backgroundColor: ({ colorStyle }: AlertBoxStyleProps) => {
      switch (colorStyle) {
        case 'yellow':
          return hexToRgbA(theme.color.oranges[50], 0.12);
        case 'red':
          return theme.color.reds[10];
        case 'blue':
          return theme.color.blues[10];
        case 'green':
          return theme.color.greens[10];
        default:
          return hexToRgbA(theme.color.oranges[50], 0.12);
      }
    },
  },
  iconContainer: {
    marginRight: 4,
  },
  icon: {
    width: 24,
    height: 24,
    display: 'block',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    overflowWrap: 'anywhere',
  },
}), { name: 'AlertBox', index: StylesIndexInjections.UI_MOLECULES });
